module.exports = __webpack_public_path__ + "img/stars.68f42f9f.svg";